import {
  isIconSizePercentage,
  isValidIconSizePercentage,
} from "./isIconSizePercentage";
import { isIconSizeToken } from "./isIconSizeToken";
import { type IconSize } from "./sizes";

export type ResolvedIconDimensions =
  | { mode: "token" }
  | { mode: "pixels"; value: number }
  | { mode: "percentage"; value: string };

export function resolveIconDimensions(size: IconSize): ResolvedIconDimensions {
  if (typeof size === "number") {
    return { mode: "pixels", value: size };
  }

  if (isIconSizeToken(size)) {
    return { mode: "token" };
  }

  if (isIconSizePercentage(size)) {
    if (!isValidIconSizePercentage(size)) {
      throw new Error(
        `Invalid icon size "${size}". Percentage sizes must match /^\\d+(\\.\\d+)?%$/ (e.g. "100%").`,
      );
    }
    return { mode: "percentage", value: size };
  }

  throw new Error(`Invalid icon size "${String(size)}".`);
}
